import { createPanel } from "./lib/helpers";

const initialState = {
    selectedPanel: 0,
    isDirty: false,
    panels: [],
};

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD_COLUMN":
            const withNewColumn = state.panels.map((p, i) => {
                if (i === state.selectedPanel) {
                    const newItems = p.analysis.items.map((item) => {
                        const measurements = item.measurements.map((m) => {
                            return { ...m };
                        });
                        measurements.push("");
                        const newItem = { ...item, measurements };

                        return newItem;
                    });

                    p.analysis = {
                        columnHeaders: [...p.analysis.columnHeaders, ""],
                        items: newItems,
                    };
                }

                return p;
            });

            return {
                ...state,
                isDirty: true,
                panels: withNewColumn,
            };
        case "REMOVE_COLUMN": {
            const panelsRemovedColumn = state.panels.map((p, i) => {
                if (i === state.selectedPanel) {
                    const itemsRemovedColumn = p.analysis.items.map((item) => {
                        const withRemovedMeasurement = [...item.measurements];
                        withRemovedMeasurement.splice(action.columnIndex, 1);
                        item.measurements = withRemovedMeasurement;

                        return item;
                    });

                    const withRemovedColumn = [...p.analysis.columnHeaders];
                    withRemovedColumn.splice(action.columnIndex, 1);

                    p.analysis = {
                        columnHeaders: withRemovedColumn,
                        items: itemsRemovedColumn,
                    };
                }

                return p;
            });

            return {
                ...state,
                isDirty: true,
                panels: panelsRemovedColumn,
            };
        }
        case "ADD_PANEL":
            const addedPanels = [...state.panels];
            const newPanel = createPanel();

            addedPanels.push(newPanel);

            return {
                ...state,
                isDirty: true,
                panels: addedPanels,
                selectedPanel: addedPanels.length - 1,
            };
        case "REMOVE_PANEL":
            const removedPanels = [...state.panels];
            removedPanels.splice(state.selectedPanel, 1);

            return {
                ...state,
                isDirty: true,
                panels: removedPanels,
                selectedPanel: removedPanels.length - 1,
            };
        case "UPDATE_DEEP_STATE":
            const updatedDeepPanels = state.panels.map((p, i) => {
                if (i === state.selectedPanel) {
                    p[action.section][action.key] = action.value;
                }

                return p;
            });

            return {
                ...state,
                isDirty: true,
                panels: updatedDeepPanels,
            };
        case "UPDATE_STATE":
            const updatedPanels = state.panels.map((p, i) => {
                if (i === state.selectedPanel) {
                    if (action.column === false) {
                        if (p[action.key] && p[action.key].items) {
                            p[action.key].items = action.value;
                        } else {
                            p[action.key] = action.value;
                        }
                    } else {
                        p.columns[action.column][action.key] = action.value;
                    }
                }

                return p;
            });

            return {
                ...state,
                isDirty: true,
                panels: updatedPanels,
            };
        case "SAVE_PANELS":
            return {
                ...state,
                isDirty: action.isDirty,
                panels: action.panels,
            };
        case "SET_DIRTY_FLAG":
            return {
                ...state,
                isDirty: action.isDirty,
            };
        case "SET_PANEL_INDEX":
            return {
                ...state,
                selectedPanel: action.selectedPanel,
            };
        default:
            return state;
    }
};

export { reducer, initialState };
